import * as React from 'react'
import Typography from '@mui/material/Typography'
import { ContentCentered } from '@sales-center/components'

export const HealthCheck = () => {
  return (
    <ContentCentered alignItems="center" flexDirection="column">
      <Typography component="p" variant="h4" gutterBottom>
        Live Health Check
      </Typography>
      <Typography variant="body1">
        The application is running and responsive.
      </Typography>
    </ContentCentered>
  )
}

HealthCheck.displayName = 'HealthCheck'
